// LABELS
const label_input_sel = '.form-item > input[type="text"],' +
	'.form-item > div > input[type="text"],' +
	'.form-item > input[type="number"],' +
	'.form-item > input[type="password"],' +
	'.form-item > input[type="email"],' +
	'.form-item > input[type="tel"],' +
	'.form-item > select,' +
	'.form-item > div > select,' +
	'.form-item > textarea,' +
	'.form-item > div > textarea';

Drupal.behaviors.sw_input = {
	attach: function( context, settings ) {

		$(label_input_sel, context).filter('.label-placeholder').each(function() {
			$(this).closest('.form-item').addClass('label-placeholder');
		});
		$(label_input_sel, context).trigger('focusout');

    $('input[type="checkbox"]').once('sw_input_checkbox').each(function () {
      var $input = $(this);
      $input.addClass('wrapped');
      $input.wrap('<div class="checkbox"></div>');
      $input.data('was-checked', $input.is(':checked'));
      $input.trigger('keydown');
    });
    $('input[type="radio"]').once('sw_input_radio').each(function () {
      var $input = $(this);
      $input.addClass('wrapped');
      $input.wrap('<div class="radio"></div>');
      $input.trigger('keydown');
    });

    $('.radios--buttons').once('sw_radio_buttons').each(function() {
      $(this).find('.fieldset-legend').addClass('as-h2');
      $(this).find('.option').addClass('as-b').addClass('as-b--bordered');
    });

    $('input,select').filter('.js-change-submit').once('sw_change_submit').on('click',function() {
      let $i = $(this);
      setTimeout(function() {
        $i.closest('form').find('input[type="submit"][name="op"]').not('[formnovalidate]').trigger('click');
      }, 100);
    });

    /*$('input[type="file"]').once('sw-input').each(function () {
      var $input = $(this);
      $input.unbind();
      $input.wrap('<div class="input-file '+( $(this).hasClass('error') ? 'error' : '' )+'"></div>');
      var placeholder = $input.data('placeholder');
      if ( !placeholder ) {
        placeholder = Drupal.t('Drag and drop files');
      }
      $input.parent().append('<i class="placeholder">'+placeholder+'</i><span>'+Drupal.t('Browse your device')+'</span>');
      $input.parent().prepend('<div class="photo-preview"></div>');
      // Disable any ajax buttons
      //$input.closest('.js-form-managed-file').find('input[type="submit"]').unbind().remove();
    });*/

    // Remove default drupal remove AJAX from managed_file
    $('input[name="image_remove_button"]').unbind();

	}
};

// CHECKBOX
$(document).on('change keydown', '.checkbox input[type="checkbox"]', function (e) {
  var $input = $(this);
  if ( $input.data('was-checked') === $input.is(':checked')) {
    e.preventDefault();
  }
  $input.data('was-checked', $input.is(':checked'));
  var $wrap = $input.closest('.checkbox');
  var $label = $wrap.closest('label');
  if ( !$label.length ) {
    var id = $input.attr('id');
    $label = $('label[for="'+id+'"]');
  }
  var checked = $input.is(':checked');
  var disabled = $input.is(':disabled');
  if ( checked ) {
    $wrap.add($label).addClass('checked');
    if ( $label.hasClass('as-b')) {
      $label.addClass('active');
    }
  } else {
    $wrap.add($label).removeClass('checked');
    if ( $label.hasClass('as-b')) {
      $label.removeClass('active');
    }
  }
  if ( disabled ) {
    $wrap.add($label).addClass('disabled');
  } else {
    $wrap.add($label).removeClass('disabled');
  }
});
$(document).on('click', '.checkbox', function (e) {
  //console.log(e.target);
  if ( !$(this).closest('label').length && !$(e.target).is('input[type="checkbox"]') ) {
    var I = $(this).find('input[type="checkbox"]');
    if ( !I.is(':disabled') ) {
      I.prop ( 'checked', !I.is ( ':checked' ) );
      I.trigger ( 'change' );
    }
  }
});

// RADIO
$(document).on('change keydown', '.radio input[type="radio"]', function () {
  var name = $(this).attr('name');
  $('input[type="radio"][name="'+name+'"]').each(function () {
    var $input = $(this);
    var $wrap = $input.closest('.radio');
    var $label = $wrap.closest('label');
    if ( !$label.length ) {
      var id = $input.attr('id');
      $label = $('label[for="'+id+'"]');
    }
    var checked = $input.is(':checked');
    var disabled = $input.is(':disabled');
    if ( checked ) {
      $wrap.add($label).addClass('checked');
      if ( $label.hasClass('as-b')) {
        $label.addClass('active');
      }
    } else {
      $wrap.add($label).removeClass('checked');
      if ( $label.hasClass('as-b')) {
        $label.removeClass('active');
      }
    }
    if ( disabled ) {
      $wrap.add($label).addClass('disabled');
    } else {
      $wrap.add($label).removeClass('disabled');
    }
  });
});
$(document).on('click', '.radio', function (e) {
  //console.log(e.target);
  if ( !$(this).closest('label').length && !$(e.target).is('input[type="radio"]') ) {
    var I = $(this).find('input[type="radio"]');
    if ( !I.is(':disabled') ) {
      var $switch = I.closest ( '.form-radio-switch' );
      if ( $switch.length ) {
        var Ia = $switch.find ( 'input[type="radio"]' ).eq ( 0 );
        //if ( e.offsetX < $(this).width() / 2 ) {
        if ( I.is ( ':checked' ) ) {
          I = Ia;
        }
      }
      I.prop ( 'checked', true );
      I.trigger ( 'change' );
    }
  }
});

$(document).on(
	'focusin focusout change keydown',
	label_input_sel,
	function(e) {
		var $i = $(this);
		var $l = $i.parent().find('label');
		if ( !$l.length ) {
			$l = $i.closest('.form-item').find('label');
		}
		if ( !$.trim($i.val()) && ( !$i.is(':focus') || $i.is('select')) && !$i.attr('placeholder') ) {
			$l.addClass('placeholder');
		} else {
			$l.removeClass('placeholder');
		}
	}
);

/*
// Fake submit
$(document).on('click', '.fake-submit', function( e ) {
  $(this).find('input[type="submit"]').trigger('mousedown');
});
*/


/*
// FILE
$(document).on('change', '.input-file input[type="file"]' , function () {
  var filename = $(this).val();
  filename = filename.replace(/.*[\/\\]/gi,'');
  var $i = $(this).closest('.input-file').find('i');
  $i.text(filename);
  $i.removeClass('placeholder');
});
 */

/*(function ($, Drupal) {
  Drupal.behaviors.fileAutoUpload = {}
  Drupal.behaviors.webformManagedFileAutoUpload = {}
})($, Drupal);*/

/*if (window.File && window.FileReader && window.FileList && window.Blob) {
  $(document).on('change', '.input-file input[type="file"]', function (e) {
    var $preview = $(this).closest('.form-item').find('.photo-preview');
    if ( $preview.length ) {
      var files = e.target.files;
      for (var i = 0, f; f = files[i]; i++) {
        // Only process image files.
        if (!f.type.match('image.*')) {
          continue;
        }
        var reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = (function(theFile) {
          return function(e) {
            // Render thumbnail.
            $preview.css('background-image','url('+e.target.result+')');
            $preview.closest('.input-file').addClass('input-file--with-preview');
            $preview.closest('.js-form-type-webform-image-file').addClass('with-preview');
          };
        })(f);
        // Read in the image file as a data URL.
        reader.readAsDataURL(f);
      }
    }
  });
}*/
